export interface User {
    fullName: string;
    avatar: string;
}

export const anonymousUser : User = {
    fullName: "Anonymous",
    avatar: ""
}